export class Miniature {
    classed?: string[];
    create?: any;
    data?: any;
    group: string;
    hasImage?: boolean;
    highlights: string[];
    icon: string;
    isExperimental?: boolean;
    sortingOrder: number;
    style?: Object;
    title: string;
    type: string;

    constructor(type: string, title: string, icon: string, highlights: string[], sortingOrder?: number, group?: string, style: Object = null) {
        this.type = type;
        this.title = title;
        this.icon = icon;
        this.highlights = highlights;
        this.sortingOrder = (sortingOrder) ? sortingOrder : undefined;
        this.group = (group) ? group : undefined;
        this.style = style;
    }

    static fromWidget(widget: any): Miniature {
        const result = new Miniature(widget.type, widget.name, widget.icon, widget.highlights);
        result.create = widget.__proto__.constructor;
        return result;
    }
}